import { render, staticRenderFns } from "./BatteryDetailModal.vue?vue&type=template&id=987c027c&"
import script from "./BatteryDetailModal.vue?vue&type=script&lang=js&"
export * from "./BatteryDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports